import {
    getTripRecordsService,
    createTripRecordService,
    updateTripRecordService,
    deleteTripRecordService,
} from '../../services/tripRecordsService';

export async function getTripRecords(dispatch, dispatchID) {
    dispatch({ type: 'REQUEST_GET_TRIP_RECORDS' });

    try {
        let response = await getTripRecordsService(dispatchID);

        if (response.data) {
            dispatch({ type: 'GET_TRIP_RECORDS_SUCCESS', payload: response.data });
            return response.data;
        }

        dispatch({ type: 'GET_TRIP_RECORDS_ERROR', error: response.data.errors[0] });
    } catch (error) {
        dispatch({ type: 'GET_TRIP_RECORDS_ERROR', error });
    }
}

export async function createTripRecord(dispatch, payload) {
    dispatch({ type: 'REQUEST_CREATE_TRIP_RECORD' });

    try {
        let response = await createTripRecordService(payload);

        if (response.data) {
            dispatch({ type: 'CREATE_TRIP_RECORD_SUCCESS', payload: response.data });
            return response.data;
        }

        dispatch({ type: 'CREATE_TRIP_RECORD_ERROR', error: response.data.errors[0] });
    } catch (error) {
        dispatch({ type: 'CREATE_TRIP_RECORD_ERROR', error });
    }
}

export async function updateTripRecord(dispatch, id, payload) {
    dispatch({ type: 'REQUEST_EDIT_TRIP_RECORD' });

    try {
        let response = await updateTripRecordService(id, payload);

        if (response.data) {
            dispatch({ type: 'EDIT_TRIP_RECORD_SUCCESS', payload: response.data });
            return response.data;
        }

        dispatch({ type: 'EDIT_TRIP_RECORD_ERROR', error: response.data.errors[0] });
    } catch (error) {
        dispatch({ type: 'EDIT_TRIP_RECORD_ERROR', error });
    }
}

export async function deleteTripRecord(dispatch, id) {
    dispatch({ type: 'REQUEST_DELETE_TRIP_RECORD' });

    try {
        let response = await deleteTripRecordService(id);

        if (response.data) {
            dispatch({ type: 'DELETE_TRIP_RECORD_SUCCESS', payload: response.data });
            return response.data;
        }

        dispatch({ type: 'DELETE_TRIP_RECORD_ERROR', error: response.data.errors[0] });
    } catch (error) {
        dispatch({ type: 'DELETE_TRIP_RECORD_ERROR', error });
    }
}
